import React, {useState, useCallback} from 'react';
import {DebounceInput} from 'react-debounce-input';
import { useDispatch } from 'react-redux';
import {useList} from 'react-use';
import classNames from 'classnames';
import styleModal from '../../../../components/dropdown/dropdown.module.css'

import styles from './modal.module.css';
import { getPlayers} from '../../../../actions/leader-board';
import {detectIconById} from "../../../../common/enum";

function TopicChooseUser(props) {
    const [suggestions, {set, reset}] = useList([]);
    const [message, setMessage] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [selectedPlayer, setSelectedPlayer] = useState(null);

    const dispatch = useDispatch();

    const onSearch = useCallback(async (value) => {
        if(!value) {
            reset();
            setMessage('');
            return;
        }
        try {
            setMessage('');
            const result = await dispatch(getPlayers({
                keyword: value,
                team_ids: []
            }));
            set(result);
        }catch (e) {
            reset();
            setMessage('');
        }
    }, []);

    const onSelectPlayer = useCallback((suggestion) => {
        setSelectedPlayer(suggestion);
        props.onChange(suggestion);
    }, []);

    return <div className={styles.modalWrapper}>
        <div style={{position: 'absolute', height: '100%', width: '100%'}} onClick={props.onClose}/>
        <div className={styles.modalContent}>
            <div className={styles.inputWrapper}>
                <DebounceInput
                    className={styles.inputSearch}
                    minLength={2}
                    onChange={e => onSearch(e.target.value)}
                    debounceTimeout={300}
                    placeholder="選手名" />
                <img alt='search' src='/img/action/ic_search_svg.svg'/>
            </div>
            <ul className={styles.suggestionList}>
                <div className={classNames(suggestions.length > 0 && styleModal.displayBlock)}>
                    {suggestions.map((suggestion, index) => {
                        return <div onClick={() => onSelectPlayer(suggestion)} key={index} className={styleModal.dropdownMenuItem}>
                            <div>
                                <img style={{width: 20, marginRight: 10}}
                                     src={detectIconById(suggestion.team.id)} alt="team-name"/>
                            {suggestion.player_name}
                                <span style={{
                                    color: '#74818A',
                                    fontSize: 13,
                                    marginLeft: 10
                                }}>{suggestion.uniform_number}</span>
                            </div>
                            <span className="fa fa-search form-control-feedback" />
                        </div>
                    })}
                </div>
                {message && <p className={styles.message}>{message}</p>}
            </ul>
        </div>
    </div>
}

export default TopicChooseUser;
